import React from 'react';
import { Link } from 'react-router-dom';
import { LuUser } from "react-icons/lu";
import { TbLogout, TbPencil } from "react-icons/tb";
import { useSelector } from 'react-redux';
import UserAvatar from '../UserAvatar/UserAvatar';
import { ROUTES } from '../../constants';

function NavDropDown({ toggleDropdown }) {
  const { user } = useSelector((state) => state.user);

  return (
    <>
      {/* Invisible Overlay to close dropdown when clicking outside */}
      <div className="fixed inset-0 z-10" onClick={toggleDropdown}></div>

      <div 
        className='absolute right-0 mt-3 w-56 bg-white rounded-2xl shadow-2xl shadow-slate-200 border border-slate-100 py-2 z-20 origin-top-right animate-in fade-in zoom-in duration-200'
        onClick={(e) => e.stopPropagation()} // Prevent clicks inside from closing
      >
        {/* User Info Header (Optional but Pro) */}
        <div className="px-4 py-3 border-b border-slate-50 mb-1 flex items-center gap-3">
            <UserAvatar src={user?.profileImage} name={user?.name} size={36} />
            <div className="min-w-0">
              <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest leading-none mb-0.5">Signed in as</p>
              <p className="text-sm font-bold text-slate-900 truncate">{user?.name}</p>
            </div>
        </div>

        <Link 
          to={ROUTES.userProfile(user?._id)} 
          onClick={toggleDropdown}
          className='flex items-center gap-3 px-4 py-3 text-sm font-bold text-slate-600 hover:bg-blue-50 hover:text-blue-600 transition-colors'
        >
          <LuUser size={18} />
          <span>Profile Dashboard</span>
        </Link>

        <Link 
          to={ROUTES.editProfile} 
          onClick={toggleDropdown}
          className='flex items-center gap-3 px-4 py-3 text-sm font-bold text-slate-600 hover:bg-blue-50 hover:text-blue-600 transition-colors'
        >
          <TbPencil size={18} />
          <span>Edit Profile</span>
        </Link>

        <div className="h-px bg-slate-50 my-1" />

        <Link 
          to={ROUTES.logout} 
          onClick={toggleDropdown}
          className='flex items-center gap-3 px-4 py-3 text-sm font-bold text-rose-500 hover:bg-rose-50 transition-colors'
        >
          <TbLogout size={18} />
          <span>Logout</span>
        </Link>
      </div>
    </>
  );
}

export default NavDropDown;